// Hotwire Turbo init _including_ Turbo Drive (link acceleration)
import "@hotwired/turbo-rails";
//
// Begin Stimulus controller auto-loading
//
// This will automatically load all controllers in the controllers directory
// and register them with Stimulus.
//

import { Application } from "@hotwired/stimulus";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";
import jquery from 'jquery';
import Highcharts from 'highcharts/highstock';
import HighchartsMore from 'highcharts/highcharts-more';
import 'flowbite/dist/flowbite.turbo';
HighchartsMore(Highcharts);

window.jQuery = jquery;
window.$ = jquery;
window.Highcharts = Highcharts;

const application = Application.start();
const context = require.context("./controllers", true, /^(?!.*\.test\.js$).*\.js$/);
application.load(definitionsFromContext(context));

// Load ViewComponent controllers from main app
const modernContext = require.context(
  "../../app/views/components",
  true,
  /controller\.js$/
);
modernContext.keys().forEach((key) => {
  const identifier = key
    .match(/\.\/(.+)\/controller\.js$/)?.[1]
    ?.replace(/_/g, "-")
    ?.replace(/\//g, "--");

  if (identifier) {
    application.register(identifier, modernContext(key).default);
  }
});

// Load Stimulus controllers from packages
const packageControllerContext = require.context("../../packages", true, /app\/javascript\/controllers\/.*(?<!\.test)\.js$/)
packageControllerContext.keys().forEach((key) => {
  // Extract identifier from path like "./oms/app/javascript/controllers/oms/filter_sidebar_controller.js"
  const match = key.match(/\.\/(.+)\/app\/javascript\/controllers\/(.+)_controller\.js$/)
  if (match) {
    // Format: package-name--controller-name
    // e.g., "oms--filter-sidebar" or "oms--oms--filter-sidebar"
    const packageName = match[1]
    const controllerPath = match[2].replace(/_/g, "-")

    // Handle nested controller paths (e.g., oms/filter_sidebar becomes oms--filter-sidebar)
    const controllerName = controllerPath.replace(/\//g, "--")

    const identifier = `${packageName}--${controllerName}`

    application.register(identifier, packageControllerContext(key).default)
  }
})

window.Stimulus = application;

//
// End Stimulus controller auto-loading
//
